import { IUnit } from '../Unit/Unit-types';
import { ITeamResource } from '../Game/Game-types';

export const COLOR_BLACK = 'black';
export const COLOR_WHITE = 'white';

export interface IPlayerResource {
    id: number;
    userId: number;
    gameId: string;
    teamId: string;
    turn: number;
    hasInitiative: boolean;
    prevSkillRating: number;
    nextSkillRating: number;
}

export interface IPlayerResponseWithUser extends IPlayerResource {
    user: {
        id: string;
        username: string;
    }
}

export interface IPlayerGameState extends IPlayerResource {
    units: IUnit[];
    team: ITeamResource;
    user: {
        id: string;
        username: string;
    }
}

export const ranks: string[] = [
	'bronze',
	'silver',
	'gold',
	'platinum',
	'diamond',
	'masters',
	'grandmaster',
];

export function getPlayerRank(skillRating: number): string | null {
	if (skillRating < 1500) return 'bronze';
	if (skillRating < 2000) return 'silver';
	if (skillRating < 2500) return 'gold';
	if (skillRating < 3000) return 'platinum';
	if (skillRating < 3500) return 'diamond';
	if (skillRating < 4000) return 'masters';
	if (skillRating <= 5000) return 'grandmaster';

	return null;
}
